import {InviteCta} from '@/ui/components/InviteCta/InviteCta';

import {Intro} from './Intro';

import s from './Intro.module.css';

interface Props {
  className?: string;
}

export function InviteIntro({className}: Props): JSX.Element {
  return (
    <Intro className={className}>
      <div className={s.ctaWrapper}>
        <InviteCta />
      </div>
    </Intro>
  );
}
